import axios from 'axios';
import config from '../config'
import auth from './auth'
import store from '../store'
import messages from "./messages"

const rest = axios.create({
    baseURL: config.api_server
});

rest.interceptors.request.use(function(config){
    const token = auth.getAuthHeader();
    if (token) {
        config.headers.common['Authorization'] = token
    }
    return config
});

rest.interceptors.response.use(null, function(error) {
    if(error.response.data.type === "UnauthorizedTokenInvalid" || error.response.data.type === "UnauthenticatedTokenInvalid")
    {
        auth.logout()
    }
    return Promise.reject(error);
})

export default (Vue) => {
    Object.defineProperties(Vue.prototype, {
        $rest: {
            get() {
                return rest;
            }
        }
    });
};


// WEBPACK FOOTER //
// ./src/utils/rest.js